import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from 'core/route.protected';
import Loading from 'components/_common/Loading';
import TripFeeList from './TripFee.list';
import TripFeeUpdate from './TripFee.update';

function TripFee() {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <TripFeeList />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/add"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <TripFeeUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/update/:id"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <TripFeeUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>
            </Routes>
        </>
    );
}

export default TripFee;